import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { ChevronLeft, Trophy, LogIn, Ticket } from "lucide-react";

export default function JoinLeague() {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/leagues/join", { code: code.toUpperCase() });
      toast.success(`🎉 Sei entrato in ${data.name}! Scegli la tua squadra.`);
      nav(`/lega/${data.league_id}`);
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 relative overflow-hidden">
      <div className="fixed inset-0 pointer-events-none -z-10">
        <div className="absolute top-0 -left-20 w-[500px] h-[500px] bg-emerald-500/15 rounded-full blur-3xl"/>
        <div className="absolute bottom-0 -right-20 w-[500px] h-[500px] bg-amber-500/15 rounded-full blur-3xl"/>
      </div>

      <nav className="border-b border-slate-800/60 backdrop-blur-xl bg-slate-950/70">
        <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-center gap-2 text-slate-400 hover:text-white" data-testid="back-dashboard">
            <ChevronLeft size={18}/> Dashboard
          </Link>
          <div className="flex items-center gap-3">
            <Trophy size={20} className="text-amber-400"/>
            <span className="font-black uppercase tracking-wider text-lg">Fanta Business</span>
          </div>
        </div>
      </nav>

      <main className="max-w-md mx-auto px-6 py-16">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-emerald-500/40 bg-emerald-500/10 text-emerald-300 text-xs font-bold tracking-widest uppercase mb-4">
          <Ticket size={12}/> Unisciti
        </div>
        <h1 className="text-4xl sm:text-5xl font-black tracking-tight mb-3" data-testid="join-title">Codice invito 🎟️</h1>
        <p className="text-slate-400 text-sm mb-8">Inserisci il codice ricevuto dall'admin della lega. Poi potrai scegliere una squadra libera.</p>

        <form onSubmit={onSubmit} className="border border-slate-800 rounded-lg bg-slate-900 p-6 space-y-4">
          <div>
            <label className="text-xs tracking-widest text-slate-400 uppercase font-bold block mb-2">Codice</label>
            <input className="w-full bg-slate-950 border border-slate-700 rounded-md px-4 py-3 font-mono tracking-[0.4em] text-lg uppercase focus:border-emerald-500 focus:outline-none focus:ring-1 focus:ring-emerald-500"
              required maxLength={8} value={code} onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="ABC123" data-testid="join-code-input"/>
          </div>
          <button type="submit" disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold uppercase tracking-wider disabled:opacity-50 shadow-lg shadow-emerald-500/20 transition-all hover:-translate-y-0.5"
            data-testid="join-submit">
            <LogIn size={16}/>
            {loading ? "Verifica…" : "🚀 Entra in lega"}
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-slate-500">
          Non hai un codice? <Link to="/lega/nuova" className="text-amber-400 hover:text-amber-300 font-bold">Crea la tua lega</Link>
        </div>
      </main>
    </div>
  );
}
